import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CouponsectionService } from 'src/app/services/couponsection.service';
import { DatePipe } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
// import { NgbDate, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { ExcelDataProvider } from 'src/app/_Core/_Providers/excel.provider';
// import { DateService } from 'src/app/_Core/_Services/date.service';
// import { AppStateProvider } from 'src/app/_Core/_Providers/app-state.provider';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { DateService } from 'src/app/services/date.service';
import { NgbModal, ModalDismissReasons, NgbCalendar, NgbDate, NgbDateAdapter, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { Couponsection } from 'src/app/model/couponsection.model';

@Component({
  standalone: false,
  selector: 'app-coupon-bulk-upload-preview',
  templateUrl: './coupon-bulk-upload-preview.component.html',
  styleUrls: ['./coupon-bulk-upload-preview.component.scss']
})

export class CouponBulkUploadPreviewComponent implements OnInit, OnDestroy {

  public couponsection = new Couponsection();

  name: boolean;
  fieldErrors: any[];
  mobile: any;
  email: any;
  guestName: any;
  guestMobile: boolean;
  guestEmail: any;
  vehicleNumber: any;
  vehicleType: any;
  floor: any;
  buildingName: any;
  formatDate: string;
  buildingTitle: string = '';
  amorpm: boolean = false;
  amorpm1: boolean = false;
  normalizeTime: any;
  remarks: string = '';
  startTimePlaceholder: string = '';
  endTimePlaceholder: string = '';
  buildingProperty: any = [];
  floorProperty: any = [];
  floorTitle: any;
  tableHeaders: any[] = [];
  tableBody: any = [];
  selectAll: boolean = false;
  popover: any = null;
  meridian: boolean = true;
  startTime = { hour: 7, minute: 0 };

  data: any;
  fullname: string;
  mobileNumber: any;
  emailId: string;
  myCompanyData: any;
  buildingId: any;
  guestList: any;
  floorCount: any;
  floorList: any;
  vehicleTypeList: any;
  meetingPurposeData: any;
  tempMeetingPurposeData: any;
  meetingPurpose: any;
  t0600Vmsguests: any = [];
  allCouponData: any = [];
  vegetationNotes: any = [];
  mdate: any;
  selectedDate: any;
  userId: any;
  mend: any;
  tempTime: any;
  tempEndTime: any;
  id: any;
  tempGuestList: any = [];
  showError: boolean;
  errName: any;
  errfloor: any;
  sDate: any;
  minDate = undefined;
  fDate: any;
  time1: any;
  time2: any;
  validationError: any[];
  isValid: any[];
  isValidtRow: any[];
  totalInValidRows: number;
  totalValidRows: number;
  data2: any;
  isOperationCompleted: boolean;
  tempHeaders: any[];
  validationEr: boolean;
  errDate: any;
  basementCount: any;

  couponStartDate: any;
  couponEndDate: any;
  selectedToDate: any;
  formatToDate: any;
  stDate: any;
  edDate: any;

  myForm!: FormGroup;

  constructor(
    private router: Router,
    // private dateSrv: DateService,
    public datepipe: DatePipe,
    private ngbDatepickerConfig: NgbDatepickerConfig,
    private excelProvider: ExcelDataProvider,
    private activatedRoute: ActivatedRoute,
    private couponsectionService: CouponsectionService,
    private appStateSrv: AppStateProvider,
    private dateSrv: DateService,
    private dateAdapter: NgbDateAdapter<string>,
    private formBuilder: FormBuilder,
  ) {
    const current = new Date();
    ngbDatepickerConfig.minDate = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate(),
    };

    ngbDatepickerConfig.outsideDays = 'hidden';

    this.myForm = new FormGroup({
      startdate: new FormArray([]),
      enddate: new FormArray([]),
    });
  }

  ngOnInit(): void {

    localStorage.setItem('expandNavCreateview', 'true');

    this.activatedRoute.queryParams.subscribe(res => {
      this.id = res.id ? res.id : null
    })

    this.data = this.couponsectionService.getExcelData();
    if (this.data != null) {
      // this.processApiResponse(JSON.parse(this.data).map(obj => ({ ...obj, validationIssues: true, isValid: true, isValidRow: true })));
      this.processApiResponse(JSON.parse(this.data).map(obj => ({ ...obj })));
    }

    const jsDate = new Date();
  }

  ngOnDestroy() {
    localStorage.removeItem('expandNavCreateview');
  }

  newNotes(
    startdate?: string,
    enddate?: string,
  ): FormGroup {
    return this.formBuilder.group({
      startdate: [startdate ? startdate : ''],
      description: [enddate ? enddate : ''],
    });
  }

  convertFormat(y, m, d) {
    return y + '-' + m + '-' + d;
  }

  onClickedOutside(e: Event) {
  }

  openPopover(popover) {
    this.popover = popover
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  bulkInvite(data) {
    var files = data.target.files; // FileList object
    var xl2json = new this.excelProvider.ExcelToJSON();
    xl2json.parseExcel(files[0]).then(data => {
      // this.processApiResponse(JSON.parse(data).map(obj => ({ ...obj, validationIssues: true, isValid: true, isValidRow: true })));
      this.processApiResponse(JSON.parse(data).map(obj => ({ ...obj })));
    }).catch(err => {
    });
  }

  prepareTableData(tableData) {
    console.log(tableData);
    this.tableBody = [];
    this.tableHeaders = [];
    // this.tableBody = tableData
    let sampleheaders = [];

    for (let header of tableData)
      sampleheaders.push(...Object.keys(header));

    this.tableHeaders = [...new Set(sampleheaders)];

    for (let body of tableData) {
      let temp = [];
      for (let head of this.tableHeaders) {
        if (head == 'Start Date (dd-MMM-YYYY)' || head == 'Start Date') {
          //this.couponsection.bulkStartDate = this.getDateinNgbFormat(body[head]);
          body[head] = this.convertDateFormat(body[head]);
        }
        if (head == 'End Date (dd-MMM-YYYY)' || head == 'End Date') {
          //this.couponsection.bulkEndDate = this.getDateinNgbFormat(body[head]);
          body[head] = this.convertDateFormat(body[head]);
        }
        temp.push(body[head] == undefined ? '' : body[head]);
      }
      this.tableBody.push(temp);
      console.log(this.tableBody);
      this.guestList = this.tableBody
    }
  }

  convertDateFormat(inputDate: string): string {
    // Parse the input date string into a JavaScript Date object
    const parsedDate = new Date(inputDate);

    // Check if the parsing was successful
    if (!isNaN(parsedDate.getTime())) {
      // Format the date using the 'MM/dd/yyyy' format
      const formattedDate = this.datepipe.transform(parsedDate, 'dd/MM/YYYY');
      console.log(formattedDate);
      return formattedDate || ''; // Ensure a valid result or an empty string
    } else {
      return ''; // Return an empty string if parsing fails
    }
  }

  convertDateFormatReverse(inputDate: string): string {
    // Parse the input date string into a JavaScript Date object
    const parsedDate = new Date(inputDate);

    // Check if the parsing was successful
    if (!isNaN(parsedDate.getTime())) {
      // Format the date using the 'MM/dd/yyyy' format
      const formattedDate = this.datepipe.transform(parsedDate, 'MM/dd/YYYY');
      console.log(formattedDate);
      return formattedDate || ''; // Ensure a valid result or an empty string
    } else {
      return ''; // Return an empty string if parsing fails
    }
  }

  selectAllHandler() {
    if (this.selectAll) { }
  }

  selectedGuest(guestData, index) {
  }

  deleteAllInvites() {
    if (this.selectAll) {
      this.tableBody = [];
      this.tableHeaders = [];
    }
  }

  generateUniqueId(i, type) {
    return i + '__' + type;
  }

  checkIfSelected(id: string) {
    const ele = document.getElementById(id) as HTMLInputElement;
    return !ele.checked ? 'disabledClick' : ''
  }

  deleteSelected(inviteData, i) {
    if (this.checkIfSelected(i + '__th') !== 'disabledClick')
      this.tableBody.splice(i, 1)

    this.processApiResponse(this.reprepareData(this.tableBody, this.tableHeaders))
  }

  reprepareData(tb, th) {
    var finalB = []
    tb.forEach(res => {
      let bdata = {};
      res.forEach((tb, bodyIndex) => {
        th.forEach((head, headIndex) => {
          if (bodyIndex == headIndex) {
            bdata[head] = tb
          }
        })

      })
      finalB.push(bdata)
    })
    return finalB
  }

  toggleMeridian() {
    this.meridian = !this.meridian;
  }

  editSelected(from, to, i, type) {

    if (this.checkIfSelected(i + '__th') !== 'disabledClick') {
      if (document.getElementById(i + '__edit').style.display == 'block') {
        document.getElementById(i + '__edit').style.display = 'none';
        document.getElementById(i + '__save').style.display = 'block'
      } else {
        document.getElementById(i + '__edit').style.display = 'block';
        document.getElementById(i + '__save').style.display = 'none'
      }

      let fromEle = document.getElementsByClassName(from);
      let toEle = document.getElementsByClassName(to);

      for (let el of Object.keys(fromEle))
        if (document.getElementsByClassName(from)[el].style.display == 'block')
          document.getElementsByClassName(from)[el].style.display = 'none';
        else
          document.getElementsByClassName(from)[el].style.display = 'block';

      for (let el of Object.keys(toEle))
        if (document.getElementsByClassName(to)[el].style.display == 'block')
          document.getElementsByClassName(to)[el].style.display = 'none';
        else
          document.getElementsByClassName(to)[el].style.display = 'block';

      if (type == 'save') {
        let _t = [];
        for (let el of Object.keys(toEle)) {
          _t.push(document.getElementsByClassName(to)[el].value);

        }
        _t.push(true, true, true);
        this.tableBody.splice(i, 1, _t);
        console.log(this.tableBody);
        this.processApiResponse(this.reprepareData(this.tableBody, this.tableHeaders))
      }

    }
  }

  send() {

    this.allCouponData = [];

    for (let i = 0; i < this.guestList.length; i++) {

      this.couponStartDate = this.guestList[i][2];
      this.couponEndDate = this.guestList[i][3];

      let std = this.couponStartDate.split('/');
      console.log(std);
      let etd = this.couponEndDate.split('/');
      this.couponStartDate = std[1] + '/' + std[0] + '/' + std[2];
      this.couponEndDate = etd[1] + '/' + etd[0] + '/' + etd[2];

      console.log(this.couponStartDate);
      console.log(this.couponEndDate);

      // const couponData =
      // {
      //   CouponType: this.guestList[i][0],
      //   CouponTitle: this.guestList[i][1],
      //   CouponValidFrom: this.couponStartDate,
      //   CouponValidTo: this.couponEndDate,
      //   CouponValue: this.guestList[i][4],
      //   CouponCount: this.guestList[i][5],
      //   CouponDetail: this.guestList[i][6],
      //   CreatedBy: localStorage.getItem('claAdminId'),
      // }



      this.allCouponData.push({
        CouponType: this.guestList[i][0],
        CouponTitle: this.guestList[i][1],
        CouponValidFrom: this.couponStartDate,
        CouponValidTo: this.couponEndDate,
        CouponValue: this.guestList[i][4],
        CouponCount: this.guestList[i][5],
        CouponDetail: this.guestList[i][6],
        CreatedBy: localStorage.getItem('claAdminId'),
      });
    }

    // const data = {
    //   CreatedBy: localStorage.getItem('claAdminId'),
    //   IsActive: true,
    //   CouponBulkUpload: this.allCouponData,
    // };

    console.log(this.allCouponData);

    this.couponsectionService.createBulkUploadCoupon(this.allCouponData).subscribe((res) => {
      if (res?.isValid == true) {
        this.router.navigate(['/list-coupon/']);
      }
    });
  }

  validation(validate) {
    this.showError = false;
    this.errName = validate.form.controls.building?.status;
    this.errDate = validate.form.controls.fdate?.status
    if (this.errName == 'INVALID' || this.errDate == 'INVALID')
      this.showError = true;
  }

  processApiResponse(data) {

    console.log(data);

    if (data.length > 200) {
      this.appStateSrv.showToast('Coupon list cannot exceed 200');
      return;
    }

    // this.bulkInviteValidation(data);

    if (data != null) {

      this.validationError = [];
      this.isValid = [];
      this.isValidtRow = [];
      data.map(result => {
        this.validationError.push(result.validationIssues)
        this.isValid.push(result.isValid)
        this.isValidtRow.push(result.isValidRow)
      });
      this.prepareTableData(data);
      this.totalInValidRows = 0;
      this.totalValidRows = 0;
      for (let rowEmp of this.isValidtRow) {
        if (rowEmp == false)
          this.totalInValidRows++;
        else
          this.totalValidRows++;
      }
    }
  }

  bulkInviteValidation(data) {

    console.log(data);

    this.validationEr = false;

    JSON.parse(JSON.stringify(data).replace(/\s/g, "").replace(/\./g, "")).forEach((res, i) => {

      console.log(res);

      if (res.CouponCount == undefined || res.CouponCount.length == 0) {
        data[i].isValid = false
        data[i].isValidRow = false;
        data[i].validationIssues = false;
        this.validationEr = true;
      }
      if (res.CouponDetail == undefined || res.CouponDetail.length == 0) {
        data[i].isValid = false
        data[i].isValidRow = false;
        data[i].validationIssues = false;
        this.validationEr = true;
      }
      if (res.CouponTitle == undefined || res.CouponTitle.length == 0) {
        data[i].isValid = false
        data[i].isValidRow = false;
        data[i].validationIssues = false;
        this.validationEr = true;
      }
      if (res.CouponType == undefined || res.CouponType.length == 0) {
        data[i].isValid = false
        data[i].isValidRow = false;
        data[i].validationIssues = false;
        this.validationEr = true;
      }
      if (res.CouponValue == undefined || res.CouponValue.length == 0) {
        data[i].isValid = false
        data[i].isValidRow = false;
        data[i].validationIssues = false;
        this.validationEr = true;
      }
      if (res.EndDate == undefined || res.EndDate.length == 0) {
        data[i].isValid = false
        data[i].isValidRow = false;
        data[i].validationIssues = false;
        this.validationEr = true;
      }
      if (res.StartDate == undefined || res.StartDate.length == 0) {
        data[i].isValid = false
        data[i].isValidRow = false;
        data[i].validationIssues = false;
        this.validationEr = true;
      }
    });
  }

  updateTable(data) {
    this.processApiResponse(this.reprepareData(this.tableBody, this.tableHeaders))
  }

  public updateSelectedDate(date: NgbDate) {
    this.couponStartDate = date.month + '/' + date.day + '/' + date.year;
    const jsDate = new Date(date.year, date.month - 1, date.day);
    this.selectedDate = this.convertFormat(date.year, date.month, date.day);
    this.formatDate = this.dateSrv.convertDateToLocaleString(
      date.day,
      date.month - 1,
      date.year
    );
    this.newNotes(this.couponStartDate, this.edDate);
  }

  public async updateSelectedToDate(date: NgbDate) {
    this.couponEndDate = date.month + '/' + date.day + '/' + date.year;
    const jsDate = new Date(date.year, date.month - 1, date.day);
    this.selectedToDate = this.convertFormat(date.year, date.month, date.day);
    const delay = (ms) => new Promise((res) => setTimeout(res, ms));

    if (date.day < this.couponStartDate.split('/')[1]) {
      this.appStateSrv.showToast(
        'End date can not be less than start date.'
      );
      await delay(2000);
    }

    this.formatToDate = this.dateSrv.convertDateToLocaleString(
      date.day,
      date.month - 1,
      date.year
    );
    this.newNotes(this.couponStartDate, this.couponEndDate);
  }

  getDateinNgbFormat(date) {
    let dt = (date.split('T')[0]).split('-')
    let fDate = {
      year: parseInt(dt[2]),
      month: parseInt(dt[0]),
      day: parseInt(dt[1])
    }
    return fDate
  }

}


